// extracted by mini-css-extract-plugin
export default {"header":"style_header__JdwSx","headerTigerX":"style_headerTigerX__Tap+S","loader":"style_loader__vs-5R","empty":"style_empty__c93rI"};